import React, { useState } from 'react';
import { Sidebar } from './Sidebar';
import { KonzernUebersichtPage } from '../../pages/KonzernUebersichtPage';
import { HeatmapPage } from '../../pages/HeatmapPage';
import { GeneralStimmenPage } from '../../pages/GeneralStimmenPage';
import { ActionHubPage } from '../../pages/ActionHubPage';
import { CompetitorRadarPage } from '../../pages/CompetitorRadarPage';
import { ThemenvergleichPage } from '../../pages/ThemenvergleichPage';
import { KonzernStimmungPage } from '../../pages/KonzernStimmungPage';
import { MarktStimmungPage } from '../../pages/MarktStimmungPage';
export function DashboardLayout() {
  const [activeTab, setActiveTab] = useState('konzern-uebersicht');
  // Shared market selection state for Markt-Reputation pages
  const [selectedMarket, setSelectedMarket] = useState<string | null>(null);
  const renderPage = () => {
    switch (activeTab) {
      // Konzern-Reputation
      case 'konzern-uebersicht':
        return <KonzernUebersichtPage data-id="element-1" />;
      case 'heatmap':
        return <HeatmapPage data-id="element-2" />;
      case 'general-stimmen':
        return <GeneralStimmenPage data-id="element-3" />;
      case 'konzern-stimmung':
        return <KonzernStimmungPage data-id="element-4" />;
      // Markt-Reputation
      case 'markt-stimmung':
        return <MarktStimmungPage selectedMarket={selectedMarket} onMarketChange={setSelectedMarket} data-id="element-5" />;
      case 'bewertungs-hub':
        return <ActionHubPage selectedMarket={selectedMarket} onMarketChange={setSelectedMarket} data-id="element-6" />;
      // Wettbewerb
      case 'bewertungsvergleich':
        return <CompetitorRadarPage data-id="element-7" />;
      case 'themenvergleich':
        return <ThemenvergleichPage data-id="element-8" />;
      default:
        return <KonzernUebersichtPage data-id="element-9" />;
    }
  };
  return <div className="min-h-screen bg-obi-light flex" data-id="element-10">
      <Sidebar activeTab={activeTab} onTabChange={setActiveTab} data-id="element-11" />

      {/* Main Content Wrapper - adjusted margin for sidebar */}
      <div className="flex-1 flex flex-col ml-[72px] lg:ml-[280px] transition-all duration-300" data-id="element-12">
        <main className="flex-1 relative overflow-hidden" data-id="element-13">{renderPage()}</main>
      </div>
    </div>;
}